module.exports = __webpack_public_path__ + "static/why_2-7d9f0b8b01f60835fa11cee8f3ec8978.gif";